/* TATC - Social Media Grid
   Supports:
   - Scroll reveal (IntersectionObserver per-card)
   - Page-load reveal (add .is-visible to all cards; CSS handles delays)
*/

(function () {
  'use strict';

  var SELECTOR_ROOT = '[data-tatc-smg-root]';
  var SELECTOR_CARD = '[data-tatc-smg-card]';

  function prefersReducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function revealCard(card) {
    if (!card) return;
    card.classList.add('is-visible');
  }

  function revealAll(root) {
    if (!root) return;
    root.querySelectorAll(SELECTOR_CARD).forEach(revealCard);
  }

  function initScrollReveal(root) {
    if (!('IntersectionObserver' in window)) {
      revealAll(root);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          revealCard(entry.target);
          obs.unobserve(entry.target);
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -48px 0px' }
    );

    root.querySelectorAll(SELECTOR_CARD).forEach(function (card) {
      observer.observe(card);
    });

    root._tatcSmgObserver = observer;
  }

  function initSection(root) {
    if (!root || root.dataset.tatcSmgInit === 'true') return;

    var animOn = root.getAttribute('data-tatc-smg-anim') === 'on';
    var trigger = root.getAttribute('data-tatc-smg-anim-trigger') || 'scroll';

    if (!animOn || prefersReducedMotion()) {
      revealAll(root);
      root.dataset.tatcSmgInit = 'true';
      return;
    }

    if (trigger === 'page-load') {
      // Let CSS handle the stagger via --tatc-smg-index.
      requestAnimationFrame(function () {
        revealAll(root);
      });
      root.dataset.tatcSmgInit = 'true';
      return;
    }

    initScrollReveal(root);
    root.dataset.tatcSmgInit = 'true';
  }

  function destroySection(root) {
    if (!root) return;
    if (root._tatcSmgObserver) {
      root._tatcSmgObserver.disconnect();
      delete root._tatcSmgObserver;
    }
    delete root.dataset.tatcSmgInit;
    root.querySelectorAll(SELECTOR_CARD).forEach(function (card) {
      card.classList.remove('is-visible');
    });
  }

  function initAll() {
    document.querySelectorAll(SELECTOR_ROOT).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector(SELECTOR_ROOT);
    if (root) initSection(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector(SELECTOR_ROOT);
    if (root) destroySection(root);
  });

  document.addEventListener('shopify:section:select', function (event) {
    var root = event.target.querySelector(SELECTOR_ROOT);
    if (root) revealAll(root);
  });
})();

